import { ApolloError, ServerError, ServerParseError } from '@apollo/client'
import { GraphQLError, GraphQLFormattedError } from 'graphql'
import { addFeedback, FeedbackType } from '../feedback'

export function handleComponentError<T>(component: React.Component<T, { hasError: boolean }>, err: ApolloError) {
  component.setState({ hasError: true })
  handleError(err)
}

function summarizeError(errs: readonly GraphQLError[] | readonly GraphQLFormattedError[]): string {
  if (errs == null || errs.length === 0) {
    return ''
  }
  return errs.map(err => err.message).join(', ')
}

function extractNetworkErrorMsg(err: Error | ServerParseError | ServerError | null): string {
  if (err == null) {
    return ''
  }
  if ((err as ServerError).result) {
    const serverErr = err as ServerError
    /**
     * If the ServerError result has a message field, extract that as the error message
     * See https://github.com/dynasty-com/infra/blob/4e65640ace96e5a8a5284fd82c5e109781a15554/terraform/api_gateway_routing.tf#L418-L427
     */
    if (typeof serverErr.result === 'object' && serverErr.result.message) {
      return serverErr.result.message
    }
  }
  return ''
}

export function computeErrorMessage(err: ApolloError) {
  const { message, graphQLErrors, networkError, extraInfo } = err
  console.error({ message, graphQLErrors, networkError, extraInfo })
  const errMsg = summarizeError(graphQLErrors) || extractNetworkErrorMsg(networkError) || message
  addFeedback(errMsg, FeedbackType.ERROR)
  return errMsg
}

export function handleError(err: ApolloError) {
  computeErrorMessage(err)
}
